import { BUSINESS_TYPE_LABELS } from "./businessTypes/labels";
import { sortRows, nextSort as nextSortFor } from "./sortRows";

// Sorting for the "Who shows up most" table. Rows are marketOverview()
// advertisers. The table always loads in rank (visibility) order. The rules
// (useful first direction, blanks at the bottom, ties by rank) are in sortRows.js.

const CHANNEL_COLUMNS = ["ppc", "local", "seo", "shopping", "lsa"];

// column id -> { value(row), first: direction for the first click }
export const SORT_COLUMNS = {
  rank: { value: a => a.rank, first: "asc" },
  advertiser: { value: a => a.displayName.toLowerCase(), first: "asc" },
  type: { value: a => BUSINESS_TYPE_LABELS[a.businessType.type], first: "asc" },
  visibility: { value: a => a.visibility.score, first: "desc" },
  mobile: { value: a => a.devices.mobile.searches, first: "desc" },
  desktop: { value: a => a.devices.desktop.searches, first: "desc" },
  keywords: { value: a => a.keywords, first: "desc" },
  locations: { value: a => a.postcodes, first: "desc" },
};
for (const c of CHANNEL_COLUMNS) {
  SORT_COLUMNS[`${c}_seen`] = { value: a => a.channels[c]?.searches ?? null, first: "desc" };
  SORT_COLUMNS[`${c}_pos`] = { value: a => a.channels[c]?.avgPosition ?? null, first: "asc" };
}

const byRank = (a, b) => a.rank - b.rank;

export function nextSort(current, column) {
  return nextSortFor(current, column, SORT_COLUMNS);
}

// A sorted copy of rows. No sort (null) = visibility rank order.
export function sortAdvertisers(rows, sort) {
  return sortRows(rows, sort, SORT_COLUMNS, byRank);
}
